import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react'
import useValueMessageModal from './hooks/useValueMessageModal'
import ValueMessageTransferModal from '../components/Transfer/ValueMessageTransferModal'
import { ValueMessage } from '../../ValueNarrativesView/queries/useGetValueNarrativesQuery'

const TransferValueMessageModalContext = createContext<ReturnType<typeof useValueMessageModal> | undefined>(undefined)

const TransferValueMessageModalProvider = ({ children }: PropsWithChildren<{}>) => {
    const transferValueMessageModal = useValueMessageModal()

    return (
        <TransferValueMessageModalContext.Provider value={transferValueMessageModal}>
            <ValueMessageTransferModal />
            {children}
        </TransferValueMessageModalContext.Provider>
    )
}

export const useTransferValueMessageModalContext = () => {
    const context = useContext(TransferValueMessageModalContext)

    if (!context)
        throw new Error('useTransferValueMessageModalContext must be used within TransferValueMessageModalContext')

    const [valueMessages, setValueMessages] = useState<ValueMessage[] | null>(null)

    useEffect(() => {
        if (context.valueMessages) {
            setValueMessages(context.valueMessages)
        }
    }, [context.valueMessages])

    return { ...context, valueMessages }
}

export default TransferValueMessageModalProvider
